import script from "./MarginPicture.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarginPicture.vue?vue&type=script&setup=true&lang=ts"

import "./MarginPicture.vue?vue&type=style&index=0&id=ac5ad080&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac5ad080"]])

export default __exports__